import $ from 'jquery';

function init() {
  $('.header__navBtn').on('click', function cb(e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('.navigation').slideToggle('fast');
  });


  $('.header__switchLangBtn').on('click', function cb(e) {
    e.preventDefault();
    const $self = $(this);
    $self.toggleClass('header__switchLangBtn_active');
    if ($self.hasClass('header__switchLangBtn_active')) {
      $('.header__langLinksWrap').addClass('header__langLinksWrap_active');
    } else {
      $('.header__langLinksWrap').removeClass('header__langLinksWrap_active');
    }
  });


  $('.header__searchBtn').on('click', (e) => {
    e.preventDefault();
    $('.header__basePanel').toggleClass('header__basePanel_active');
    $('.header__searchPanel').toggleClass('header__searchPanel_active');
    if ($('.header__searchPanel').hasClass('header__searchPanel_active')) {
      $('.pageMask').fadeIn(300);
    } else {
      $('.pageMask').fadeOut(300);
    }
  });
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/header/header.js
 **/